import { _ as __assign } from './tslib.es6-86dc5b0c.js';
import { jsx } from 'react/jsx-runtime';
import { rankWith, uiTypeIs, isLayout } from '@jsonforms/core';
import { withJsonFormsLayoutProps, JsonFormsDispatch } from '@jsonforms/react';
import { S as Stack } from './Stack-236c25f5.js';

var jsonFormsVerticalLayoutTester = rankWith(3, uiTypeIs('VerticalLayout'));
var JsonFormsVerticalLayout = withJsonFormsLayoutProps(function (_a) {
    var _b, _c, _d;
    var cells = _a.cells, enabled = _a.enabled, path = _a.path, renderers = _a.renderers, schema = _a.schema, uischema = _a.uischema, visible = _a.visible;
    if (!visible || !isLayout(uischema)) {
        return null;
    }
    var shouldRenderDividers = !!((_b = uischema.options) === null || _b === void 0 ? void 0 : _b.dividers);
    var wide = !!((_c = uischema.options) === null || _c === void 0 ? void 0 : _c.wide);
    var gap = (_d = uischema.options) === null || _d === void 0 ? void 0 : _d.gap;
    return (jsx(Stack, __assign({ "$wide": wide, gap: gap, shouldRenderDividers: shouldRenderDividers }, { children: uischema.elements.map(function (child, index) {
            return (jsx(JsonFormsDispatch, { cells: cells, enabled: enabled, path: path, renderers: renderers, schema: schema, uischema: child }, index));
        }) }), void 0));
});

export { JsonFormsVerticalLayout as J, jsonFormsVerticalLayoutTester as j };
